import React, {
    useEffect,
    useRef,
    useState
} from 'react';

import { Button } from './Button';

export const ButtonWithTimer = ({
    countDown = 5,
    title,
    localize = true,
    ...restProps
}) => {
    const [timeLeft, setTimeLeft] = useState(countDown);
    const [isTimerActive, setIsTimerActive] = useState(true);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (isTimerActive && timeLeft > 0) {
            intervalRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        setIsTimerActive(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isTimerActive, timeLeft]);

    const titleText = localize && title ? Object.R(title) : title;
    const displayTitle = isTimerActive && timeLeft > 0 
        ? `(${timeLeft}) ${titleText}` 
        : titleText;

    return (
        <Button
            {...restProps}
            title={displayTitle}
            localize={false}
            disabled={isTimerActive || restProps.disabled}
        />
    );
};
